<template>
<BCard>
  <BTable ref="refInvoiceListTable" :items="fetchInvoices" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found" :sort-desc.sync="isSortDirDesc" class="position-relative">
    <!-- Column: Amount -->
    <template #cell(amount)="data">
        <p class="text-center m-0"><b>{{ formatCurrency(data.item.amount) }}</b></p>
        <div class="text-center">
            <BBadge  pill variant="light-warning" v-if="isPartialPaid(data.item.specific_status).value">{{ (isPartialPaid(data.item.specific_status).owe).toFixed(2) }}€ pendientes</BBadge>
        </div>
    </template>

    <!-- Column: Id -->
    <template #cell(id)="data">
      <BLink :to="{ name: 'invoices-view', params: { id: data.item.id }}" class="font-weight-bold">
        <span class="text-nowrap">{{ data.item.name }}</span>

      </BLink>
    </template>

    <!-- Column: Invoice Status -->
    <template #cell(paid)="data">
      <div>
        <BAvatar :id="`invoice-row-${data.item.id}`" size="32" :variant="`light-${resolveInvoiceStatusVariantAndIcon(data.item.specific_status).variant}`" >
          <FeatherIcon :icon="resolveInvoiceStatusVariantAndIcon(data.item.specific_status).icon" />
        </BAvatar>
        <br>
        <span>{{ resolveInvoiceStatusVariantAndIcon(data.item.specific_status).label }}</span>
      </div>
    </template>

    <!-- Column: Issued Date -->
    <template #cell(dates)="data">
        <small>
          <span class="text-nowrap"><b>Emisión: </b>{{ format(new Date (data.item.emit_date), 'dd-MM-yyyy') }}</span><br>
          <span class="text-nowrap"><b>Vencimiento: </b>{{ data.item.payment_date ? format(new Date (data.item.payment_date), 'dd-MM-yyyy') : '(No definida)' }}</span>
        </small>
    </template>
  </BTable>
  <div class="mx-2 mb-2">
      <BRow>
        <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
          <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
        </BCol>
        <!-- Pagination -->
        <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

          <BPagination v-model="currentPage" :total-rows="totalInvoices" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </BPagination>

        </BCol>

      </BRow>
  </div>
</BCard>
</template>

<script>
  import { BTab, BTabs, BCard, BAlert, BLink, BTable, BAvatar, BRow, BCol, BPagination} from 'bootstrap-vue'
  import { ref, inject }  from '@vue/composition-api'
  import AccountsViewTabGeneral from './AccountsViewTabGeneral'
  import AccountsViewTabBilling from './AccountsViewTabBilling'
  import useInvoicesList from '../../invoices/invoices-list/useInvoicesList'
  import currency from '@/utils/currency'
  import { format } from 'date-fns';
  
  export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, AccountsViewTabGeneral, AccountsViewTabBilling, BTable, BAvatar, BRow, BCol, BPagination}, 
    setup() {
      const account = inject('account')
      const invoices = ref(null)
      const { formatCurrency } = currency()

      const {  fetchInvoices, perPage, currentPage, totalInvoices, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refInvoiceListTable, accountFilter, refetchData, resolveInvoiceStatusVariantAndIcon, isPartialPaid} = useInvoicesList()
      accountFilter.value=account.value.id
      const tableColumns = [
        { key: 'id', label: '#', sortable: true },
        { key: 'amount', label: 'Importe', sortable: true },
        { key: 'dates', label: 'Fechas', sortable: true },
        { key: 'payment_method', label: 'Método de pago', sortable: true },
        { key: 'paid', label: 'Pagado', sortable: true },
      ]
      return {
        account,
        perPage,
        totalInvoices,
        currentPage,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        fetchInvoices,
        tableColumns,
        formatCurrency,
        isPartialPaid,
        format,
        resolveInvoiceStatusVariantAndIcon,
        dataMeta,
        refInvoiceListTable
      }
    },
  }
  </script>